import type { ToggleCommunityConfigurationSidebarEvent } from './types'

import { EventsName } from '../constants'

export const toggleCommunityConfigurationSidebarEventDispatch = (
  payload: ToggleCommunityConfigurationSidebarEvent
) =>
  window.dispatchEvent(
    new CustomEvent(EventsName.COMMUNITY_CONFIGURATION_SIDEBAR, { detail: payload })
  )

export const toggleCommunityConfigurationSidebarEventListener = (
  listener: (event: Event) => void
) => {
  window.addEventListener(EventsName.COMMUNITY_CONFIGURATION_SIDEBAR, listener)

  return () => window.removeEventListener(EventsName.COMMUNITY_CONFIGURATION_SIDEBAR, listener)
}
